const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/_settingsLayout/settings/analytics/videos/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";

// Empty component as VideosAnalytics is rendered through iframe in the parent layout route's AnalyticsV2FilterUpgrade component

export const Route = createFileRoute("/_protected/_settingsLayout/settings/analytics/videos")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});